import { useContext } from 'react';
import CameraRewindsPlaceholderWrapper from 'components/CameraRewindsPlaceholder/CameraRewindsPlaceholder';
import { RewindsCamPlayerWithScrubberControlContextProvider } from 'contexts/RewindsCamPlayerWithScrubberControlContext';
import { RewindsContext } from 'contexts/RewindsContext';
import { SpotDetails } from 'types/spot';
import { CamPlayerKbygRewinds, CamPlayerKbygRewindsProps } from './CamPlayerKbygRewinds';

interface CamPlayerKbygRewindsWrapperProps extends CamPlayerKbygRewindsProps {
  spot?: SpotDetails;
}

const CamPlayerKbygRewindsWrapper = (props: CamPlayerKbygRewindsWrapperProps) => {
  const { currentPlaylist, currentTimestamp } = useContext(RewindsContext);

  return props?.camera ? (
    <RewindsCamPlayerWithScrubberControlContextProvider
      currentPlaylist={currentPlaylist}
      currentTimestamp={currentTimestamp}
    >
      <CamPlayerKbygRewinds {...props} />
    </RewindsCamPlayerWithScrubberControlContextProvider>
  ) : (
    <CameraRewindsPlaceholderWrapper primaryCam={props?.camera} spot={props?.spot} />
  );
};

export default CamPlayerKbygRewindsWrapper;
